export enum LOCAL_STORAGE_KEYS {
  QUIZ_TEST_TASK_FINISHED_DUE_TO_TIMEOUT = 'isQuizTestTaskFinishedDueToTimeout',
  RESCHEDULE_EVENT = 'rescheduleEvent',
  SESSION_ID = 'sessionId',
  START_VIDEO_INTERVIEW_RECORD = 'startVideoInterviewRecord',
  USER_SOURCE = 'user_source',
  ANALYTICS_ID = 'analyticsId',
  VISITED_STEPS = 'visitedQuestionnaireSteps',
}
